export default "/images/vendor/flag-icon-css/flags/1x1/ca.svg?4549a2d2d66577e077c9a020dc18451e";